import { Icon, IconProps } from '@chakra-ui/react'

const LocationIconFilled = ({ ...rest }: IconProps) => {
  return (
    <Icon
      width="40"
      height="50"
      viewBox="0 0 40 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20 25C21.375 25 22.5525 24.51 23.5325 23.53C24.5108 22.5517 25 21.375 25 20C25 18.625 24.5108 17.4475 23.5325 16.4675C22.5525 15.4892 21.375 15 20 15C18.625 15 17.4483 15.4892 16.47 16.4675C15.49 17.4475 15 18.625 15 20C15 21.375 15.49 22.5517 16.47 23.53C17.4483 24.51 18.625 25 20 25ZM20 49.0625C19.6667 49.0625 19.3333 49 19 48.875C18.6667 48.75 18.375 48.5833 18.125 48.375C12.0417 43 7.5 38.0108 4.5 33.4075C1.5 28.8025 0 24.5 0 20.5C0 14.25 2.01083 9.27083 6.0325 5.5625C10.0525 1.85417 14.7083 0 20 0C25.2917 0 29.9475 1.85417 33.9675 5.5625C37.9892 9.27083 40 14.25 40 20.5C40 24.5 38.5 28.8025 35.5 33.4075C32.5 38.0108 27.9583 43 21.875 48.375C21.625 48.5833 21.3333 48.75 21 48.875C20.6667 49 20.3333 49.0625 20 49.0625Z"
        fill="black"
      />
    </Icon>
  )
}

export default LocationIconFilled
